<template>
  <div class="nb">
    <div class="ny-body ny-register">
      <el-row>
        <el-col :span="12" class="left">
          <div class="form-box">
            <p style="color: #0e9aef;">{{registerInfo.validateInfo}}</p>
            <div class="input-box input-box1 onfocusstyle user-word">
              <label for="username" class="icon-user"></label>
              <el-input
                type="text"
                v-model="registerInfo.username"
                id="username"
                placeholder="用户名"
                maxlength="20"
                autocomplete="off"
              ></el-input>
              <div class="Validform_checktip formtip">
                <span class="i-tip"><i></i><label>支持中文、字母、数字、" - "" _ "的组合</label></span>
              </div>
            </div>
            
            <div class="input-box onfocusstyle position-input p-w">
              <label class="icon-phone" for="mobile"></label>
              <el-input
                type="text"
                id="mobile"
                v-model="registerInfo.tel"
                placeholder="手机号码"
                maxlength="11"
                autocomplete="off"
              ></el-input>
              <div class="Validform_checktip formtip">
                <span class=""><i></i><label></label></span>
              </div>
            </div>
            
            <div class="input-box yzm-box onfocusstyle y-w">
              <label class="icon-yzm" for="smscode"></label>
              <el-button
                class="hq-yzm active"
                id="btnSendCode"
                @click="sendTelMessageCode()"
                :disabled="registerInfo.buttonInfo !== '验证码'"
              >{{registerInfo.buttonInfo}}</el-button>
              <el-input
                type="text"
                v-model="registerInfo.messageCode"
                id="smscode"
                maxlength="8"
                placeholder="请输入短信验证码"
                class="phoneyzm"
              ></el-input>
              <div class="Validform_checktip formtip">
                <span class=""><i></i><label></label></span>
              </div>
            </div>
            
            <div class="input-box onfocusstyle pass-w">
              <label class="icon-setpassw" for="password"></label>
              <el-input
                type="password"
                v-model="registerInfo.password"
                id="password"
                placeholder="请输入密码"
                maxlength="20"
                min="8"
                autocomplete="off"
                show-password
              ></el-input>
              <div class="Validform_checktip formtip">
                <span class="i-tip"><i></i><label>建议使用字母、数字和符号两种及以上的组合，6-20个字符</label></span>
              </div>
            </div>
            
            <div class="input-box onfocusstyle position-input pass-w2">
              <label class="icon-setpassw" for="repassword"></label>
              <el-input
                type="password"
                v-model="registerInfo.repassword"
                id="repassword"
                placeholder="请再次输入密码"
                maxlength="20"
                show-password
              ></el-input>
            </div>
            
            <div class="check onfocusstyle" style="position: relative;">
              <el-checkbox v-model="agreeChecked" id="agree">&nbsp;&nbsp;我已阅读并同意</el-checkbox>
              <a href="javascript:void(0);" class="blue" @click="showTerms">《服务条款》</a>
              <a href="javascript:void(0);" class="blue" @click="showPrivacy">《隐私政策》</a>
            </div>
            
            <div class="input-box sub-box">
              <el-button type="primary" id="reg" @click="doRegister">注册</el-button>
            </div>
          </div>
        </el-col>
        
        <el-col :span="12" class="right">
          <div class="hezuo oauth">
            <h4>如果您已注册，请<a href="javascript:void(0);" @click="_doLogin" class="blue">直接登录</a></h4>
            <p style="border-top: dashed 1px #ddd;margin: 15px auto;"></p>
            <ul></ul>
          </div>
        </el-col>
      </el-row>
    </div>

    <terms-dialog ref="termsDialog"></terms-dialog>
    <privacy-dialog ref="privacyDialog"></privacy-dialog>
  </div>
</template>

<script>
import TermsDialog from '@/components/plateform/register/TermsDialog'
import PrivacyDialog from '@/components/plateform/register/PrivacyDialog'
import { registerUser, sendMessageCode } from '@/api/plateform/registerApi'

export default {
  name: 'Register',
  components: {
    TermsDialog,
    PrivacyDialog
  },
  data() {
    return {
      registerInfo: {
        username: '',
        password: '',
        repassword: '',
        errorInfo: '',
        validateInfo: '',
        tel: '',
        messageCode: '',
        logo: '',
        levelCd: '03',
        buttonInfo: "验证码"
      },
      agreeChecked: false,
      timer: null
    }
  },
  methods: {
    showTerms() {
      this.$refs.termsDialog.open()
    },
    showPrivacy() {
      this.$refs.privacyDialog.open()
    },
    validate() {
      if (!this.registerInfo.username) {
        this.registerInfo.validateInfo = '用户名不能为空'
        return false
      }
      if (this.registerInfo.username.length < 4 || this.registerInfo.username.length > 12) {
        this.registerInfo.validateInfo = '用户名长度必须在4位至12位'
        return false
      }
      if (!this.registerInfo.password) {
        this.registerInfo.validateInfo = '密码不能为空'
        return false
      }
      if (this.registerInfo.password.length < 6 || this.registerInfo.password.length > 12) {
        this.registerInfo.validateInfo = '密码长度必须在6位至12位'
        return false
      }
      if (!this.registerInfo.tel) {
        this.registerInfo.validateInfo = '手机号不能为空'
        return false
      }
      if (!/^1[3-9]\d{9}$/.test(this.registerInfo.tel)) {
        this.registerInfo.validateInfo = '不是有效的手机号'
        return false
      }
      if (!this.registerInfo.messageCode) {
        this.registerInfo.validateInfo = '验证码不能为空'
        return false
      }
      if (!/^\d+$/.test(this.registerInfo.messageCode)) {
        this.registerInfo.validateInfo = '验证码必须是数字'
        return false
      }
      return true
    },
    async doRegister() {
      if (!this.validate()) {
        return
      }
      if (!this.agreeChecked) {
        this.$message.warning('请先勾选平台协议')
        return
      }
      
      try {
        const res = await registerUser(this.registerInfo)
        if (res.code === '0') {
          this.$message.success('注册成功')
          if (this.registerInfo.levelCd === '03') {
            this.$router.push('/pageLR.html#/pages/plateform/login')
          } else {
            this.$router.push("/user.html#/pages/frame/login")
          }
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('注册失败:', error)
        this.$message.error('注册失败')
      }
    },
    async sendTelMessageCode() {
      if (!/^1[3-9]\d{9}$/.test(this.registerInfo.tel)) {
        this.$message.warning('手机号码为空或不正确，不能发送验证码')
        return
      }

      if (this.registerInfo.buttonInfo !== '验证码') {
        return
      }

      this.messageCodeTimer()
      
      try {
        const res = await sendMessageCode({ tel: this.registerInfo.tel })
        this.registerInfo.validateInfo = res
      } catch (error) {
        console.error('获取验证码失败:', error)
        this.$message.error('手机验证码获取异常')
      }
    },
    messageCodeTimer() {
      let num = 60
      this.registerInfo.buttonInfo = `${num} 秒后重试`
      
      this.timer = setInterval(() => {
        num--
        this.registerInfo.buttonInfo = `${num} 秒后重试`
        if (num === 0) {
          clearInterval(this.timer)
          this.registerInfo.buttonInfo = '验证码'
        }
      }, 1000)
    },
    _doLogin() {
      this.$router.push('/pageLR.html#/pages/plateform/login')
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }
}
</script>

<style scoped>
.nb {
  width: 100%;
}
.ny-body {
  display: flex;
  width: 100%;
}
.left, .right {
  padding: 20px;
}
.input-box {
  position: relative;
  margin-bottom: 20px;
}
.hq-yzm {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
}
.sub-box {
  margin-top: 30px;
}
.blue {
  color: #0e9aef;
  cursor: pointer;
}
</style>